export default function StudioIcon({ name = 'spark', size = 20 }) {
  const paths = {
    spark: 'm12 3 2.5 6.5L21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5L12 3Z',
    image: 'M4 4h16v16H4z M4 16l5-5 4 4 3-3 4 4 M15 8h.01',
    video: 'M4 5h16v14H4z M10 9l5 3-5 3z',
    audio: 'M4 10v4 M8 6v12 M12 3v18 M16 6v12 M20 10v4',
    text: 'M4 5h16 M12 5v15 M8 20h8',
    settings: 'M4 7h16 M4 17h16 M8 4v6 M16 14v6',
    arrow: 'M5 12h14 M13 6l6 6-6 6',
    history: 'M4 10a8 8 0 1 1 1 7 M4 4v6h6 M12 8v5l3 2',
    microphone: 'M9 5a3 3 0 0 1 6 0v7a3 3 0 0 1-6 0V5 M5 10v2a7 7 0 0 0 14 0v-2 M12 19v3 M8 22h8',
    stop: 'M6 6h12v12H6z',
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[name] || paths.spark} /></svg>;
}
